import { FC } from 'react'
import cn from 'classnames'

import styles from './List.pcss'

interface ListElements {
	Item: FC
}

interface Props {
	direction?: 'vertical' | 'horizontal'
	divided?: boolean
}

const List: FC<Props> & ListElements = ({
	direction = 'vertical',
	divided,
	children,
}) => {
	const computedClassName = cn(
		styles.list,
		styles[direction],
		divided && styles.divided
	)

	return <ul className={computedClassName}>{children}</ul>
}

const ListItem: FC = ({ children }) => (
	<li className={styles.item}>{children}</li>
)

List.Item = ListItem

export default List
